import React from 'react';
import { DonutLegendChart } from '@/components/ui/DonutLegendChart';

export function MemberStatsBlock() {
  const data = [
    { name: 'Công việc hoàn thành', value: 45, color: '#059669' },
    { name: 'Đang thực hiện', value: 12, color: '#0284c7' },
    { name: 'Quá hạn', value: 3, color: '#e11d48' },
  ];

  return (
    <DonutLegendChart
      title="Thống kê hiệu suất"
      centerValue="60"
      centerLabel="Nhiệm vụ"
      data={data}
      total={60}
      className="h-full"
    />
  );
}
